export function resolveLoginRedirectPath(redirectPath, fallbackPath = '/') {
  if (typeof redirectPath !== 'string') {
    return fallbackPath
  }

  const normalizedPath = redirectPath.trim()
  if (!normalizedPath || normalizedPath === '/login') {
    return fallbackPath
  }

  // 只允许站内相对路径，避免跳转到外部地址或协议相对地址
  if (!normalizedPath.startsWith('/') || normalizedPath.startsWith('//')) {
    return fallbackPath
  }

  return normalizedPath
}
